export const TOGGLE_WECHAT_POPUP = 'TOGGLE_WECHAT_POPUP';
export const OPEN_WECHAT_POPUP = 'OPEN_WECHAT_POPUP';
export const SET_WECHAT_URL = 'SET_WECHAT_URL';

export const toggleWeChatPopup = () => async (dispatch) => {
  dispatch({
    type: TOGGLE_WECHAT_POPUP,
  });
};

export const openWeChatPopup = () => async (dispatch) => {
  dispatch({
    type: OPEN_WECHAT_POPUP,
  });
};

export const setWeChatUrl = (href) => async (dispatch) => {
  dispatch({
    type: SET_WECHAT_URL,
    payload: href,
  });
};
